import Swal from 'sweetalert2'

export const ImageCompressor = async (file: File): Promise<any> => {
  try {
    const maxSize = 300 * 1024
    const maxDimension = 800

    const bitmap = await createImageBitmap(file)
    const scale = Math.min(maxDimension / bitmap.width, maxDimension / bitmap.height, 1)
    const width = Math.round(bitmap.width * scale)
    const height = Math.round(bitmap.height * scale)
    const canvas = document.createElement('canvas')

    canvas.width = width
    canvas.height = height

    const ctx = canvas.getContext('2d')
    if (!ctx) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid file',
        text: 'Could not create canvas context',
      })
      return
    }

    ctx.drawImage(bitmap, 0, 0, width, height)
    let quality = 0.9

    while (quality >= 0.4) {
      const blob = await new Promise<Blob | null>((resolve) => {
        canvas.toBlob(
          (blob) => {
            // console.log('toblob', blob)
            resolve(blob)
          },
          'image/webp',
          quality,
        )
      })

      // const sizeAfter = blob?.size ?? 0
      // console.log('compressed size:', (sizeAfter / 1024).toFixed(2), 'KB')

      if (!blob) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid file',
          text: 'Could not create blob',
        })
        return
      }

      if (blob.size <= maxSize) {
        return new File([blob], `${file.name.split('.')[0]}.webp`, {
          type: 'image/webp',
        })
      }
      quality -= 0.05
    }
  } catch (error) {
    // console.error('err:', error)
    Swal.fire({
      icon: 'error',
      title: 'Unknown error',
      text: 'Something went wrong!',
    })
  }
}
